/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ControlAppCoreEnumsAuth0Roles } from './ControlAppCoreEnumsAuth0Roles';
import {
    ControlAppCoreEnumsAuth0RolesFromJSON,
    ControlAppCoreEnumsAuth0RolesFromJSONTyped,
    ControlAppCoreEnumsAuth0RolesToJSON,
} from './ControlAppCoreEnumsAuth0Roles';
import type { ControlEscalationPriority } from './ControlEscalationPriority';
import {
    ControlEscalationPriorityFromJSON,
    ControlEscalationPriorityFromJSONTyped,
    ControlEscalationPriorityToJSON,
} from './ControlEscalationPriority';

/**
 * 
 * @export
 * @interface ControlUserContactInfoAddUpdateRequest
 */
export interface ControlUserContactInfoAddUpdateRequest {
    /**
     * 
     * @type {string}
     * @memberof ControlUserContactInfoAddUpdateRequest
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof ControlUserContactInfoAddUpdateRequest
     */
    phone?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlUserContactInfoAddUpdateRequest
     */
    first_name?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlUserContactInfoAddUpdateRequest
     */
    last_name?: string;
    /**
     * 
     * @type {ControlAppCoreEnumsAuth0Roles}
     * @memberof ControlUserContactInfoAddUpdateRequest
     */
    auth0_role?: ControlAppCoreEnumsAuth0Roles;
    /**
     * 
     * @type {ControlEscalationPriority}
     * @memberof ControlUserContactInfoAddUpdateRequest
     */
    escalation_priority?: ControlEscalationPriority;
    /**
     * 
     * @type {boolean}
     * @memberof ControlUserContactInfoAddUpdateRequest
     */
    is_primary_security_contact?: boolean;
}

/**
 * Check if a given object implements the ControlUserContactInfoAddUpdateRequest interface.
 */
export function instanceOfControlUserContactInfoAddUpdateRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "email" in value;

    return isInstance;
}

export function ControlUserContactInfoAddUpdateRequestFromJSON(json: any): ControlUserContactInfoAddUpdateRequest {
    return ControlUserContactInfoAddUpdateRequestFromJSONTyped(json, false);
}

export function ControlUserContactInfoAddUpdateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlUserContactInfoAddUpdateRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'email': json['email'],
        'phone': !exists(json, 'phone') ? undefined : json['phone'],
        'first_name': !exists(json, 'first_name') ? undefined : json['first_name'],
        'last_name': !exists(json, 'last_name') ? undefined : json['last_name'],
        'auth0_role': !exists(json, 'auth0_role') ? undefined : ControlAppCoreEnumsAuth0RolesFromJSON(json['auth0_role']),
        'escalation_priority': !exists(json, 'escalation_priority') ? undefined : ControlEscalationPriorityFromJSON(json['escalation_priority']),
        'is_primary_security_contact': !exists(json, 'is_primary_security_contact') ? undefined : json['is_primary_security_contact'],
    };
}

export function ControlUserContactInfoAddUpdateRequestToJSON(value?: ControlUserContactInfoAddUpdateRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'email': value.email,
        'phone': value.phone,
        'first_name': value.first_name,
        'last_name': value.last_name,
        'auth0_role': ControlAppCoreEnumsAuth0RolesToJSON(value.auth0_role),
        'escalation_priority': ControlEscalationPriorityToJSON(value.escalation_priority),
        'is_primary_security_contact': value.is_primary_security_contact,
    };
}

